<div class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">Edit budget</h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body" *ngIf="!loading; else loadingTemplate">
        <div class="form-group m-b-2">
            <label>Category</label>
            <div>{{ categoryName || '-' }}</div>
        </div>

        <div class="form-group m-b-2">
            <label>Year</label>
            <div>{{ year }}</div>
        </div>

        <div class="form-group m-b-2">
            <label>Input mode</label>
            <div class="budget-mode-group">
                <label class="budget-mode-option">
                    <input type="radio" name="budgetMode" value="TOTAL" [(ngModel)]="mode" (ngModelChange)="onModeChanged()" />
                    <span>Total</span>
                </label>
                <label class="budget-mode-option">
                    <input type="radio" name="budgetMode" value="MONTHLY" [(ngModel)]="mode" (ngModelChange)="onModeChanged()" />
                    <span>Per month</span>
                </label>
            </div>
        </div>

        <div class="form-group m-b-3" *ngIf="mode === 'TOTAL'">
            <label for="totalBudgetAmount">Total budget for {{ year }}</label>
            <input
                id="totalBudgetAmount"
                [type]="editingTotalBudget ? 'number' : 'text'"
                step="0.00001"
                [ngModel]="editingTotalBudget ? totalBudget : formatToTwoDecimals(totalBudget)"
                (ngModelChange)="onTotalBudgetInputChanged($event)"
                (focus)="editingTotalBudget = true"
                (blur)="editingTotalBudget = false" />
            <small>Automatically distributed over 12 months.</small>
        </div>

        <div class="form-group m-b-2">
            <label>Monthly budget overview</label>
            <div class="table__overflow">
                <table class="table-view table-view--compact">
                    <tr>
                        <th>Month</th>
                        <th>Budget</th>
                    </tr>
                    <tr *ngFor="let item of monthlyBudgets">
                        <td>{{ item.label }}</td>
                        <td>
                            <input
                                [type]="mode === 'MONTHLY' ? 'number' : 'text'"
                                step="0.00001"
                                [ngModel]="mode === 'MONTHLY' ? item.budget : formatToTwoDecimals(item.budget)"
                                (ngModelChange)="onMonthlyBudgetInputChanged(item, $event)"
                                [disabled]="mode === 'TOTAL'" />
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="form-group m-b-1">
            <label>Total</label>
            <div><strong>{{ currentYearTotal | number: '1.2-2' }}</strong></div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="button button--primary" [disabled]="saving || loading" [ngClass]="{ 'button--loading': saving }" (click)="save()">
            Save
        </button>
        <button type="button" class="button button--danger" [disabled]="saving || loading" (click)="deleteBudget()">
            Delete year budget
        </button>
        <button type="button" class="button button--outline" [disabled]="saving" (click)="activeModal.dismiss()">Cancel</button>
    </div>
</div>

<ng-template #loadingTemplate>
    <app-loading-message></app-loading-message>
</ng-template>
